import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import '../assets/styles/Footer.scss'

const LINKEDIN_URL = 'https://www.linkedin.com/in/jungwoo-ryu/';

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/jungwoo-ryu" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href={LINKEDIN_URL} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href="mailto:jryu1521@gmail.com" rel="noreferrer"><EmailIcon/></a>
        <a href="tel:+16082093712" rel="noreferrer"><PhoneIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;